import {gql} from 'apollo-boost';

export const GET_CURRICULA = gql`
  query getCurricula{
    getCurricula {
      id
      code nameLocal nameEng certNameLocal certNameEng certShortNameLocal certShortNameEng currId isOpen
      degree{
        id code nameLocal nameEng
      }
      faculty{
        id code nameLocal nameEng
      }
      department{
        id code nameLocal nameEng
      }
      zoneGroup{
        id nameLocal nameEng
      }
    }
  }
`;

export const GET_CURRICULUM = gql`
  query getCurriculum($id : ID!){
    getCurriculum (
      id: $id
    ) {
      id
      code nameLocal nameEng certNameLocal certNameEng certShortNameLocal certShortNameEng currId isOpen
      degree{
        id code nameLocal nameEng
      }
      faculty{
        id code nameLocal nameEng
      }
      department{
        id code nameLocal nameEng
      }
      zoneGroup{
        id nameLocal nameEng
      }
    }
  }
`;

export const ADD_CURRICULUM = gql`
  mutation addCurriculum(
  $curriculumInput: CurriculumInput!,
  $degreeId: ID!,
  $facultyId: ID!,
  $departmentId: ID!
  $zoneGroupId: ID!
  ) {
    addCurriculum(
      curriculumInput: $curriculumInput
      degreeId: $degreeId
      facultyId: $facultyId
      departmentId: $departmentId
      zoneGroupId: $zoneGroupId
    ) {
      id
      code nameLocal nameEng certNameLocal certNameEng certShortNameLocal certShortNameEng currId isOpen
      degree{
        id code nameLocal nameEng
      }
      faculty{
        id code nameLocal nameEng
      }
      department{
        id code nameLocal nameEng
      }
      zoneGroup{
        id nameLocal nameEng
      }
    }
  }
`;

export const UPDATE_CURRICULUM = gql`
  mutation updateCurriculum(
    $id: ID!,
    $curriculumInput: CurriculumInput!,
    $degreeId: ID!,
    $facultyId: ID!,
    $departmentId: ID!
    $zoneGroupId: ID!
  ) {
    updateCurriculum(
      id: $id
      curriculumInput: $curriculumInput
      degreeId: $degreeId
      facultyId: $facultyId
      departmentId: $departmentId
      zoneGroupId: $zoneGroupId
    ) {
      id
      code nameLocal nameEng certNameLocal certNameEng certShortNameLocal certShortNameEng currId isOpen
      degree{
        id code nameLocal nameEng
      }
      faculty{
        id code nameLocal nameEng
      }
      department{
        id code nameLocal nameEng
      }
      zoneGroup{
        id nameLocal nameEng
      }
    }
  }
`;

export const DELETE_CURRICULUM = gql`
  mutation deleteCurriculum($id: ID!) {
    deleteCurriculum(
      id: $id
    ) {
      id
      code nameLocal nameEng certNameLocal certNameEng certShortNameLocal certShortNameEng currId isOpen
      degree{
        id code nameLocal nameEng
      }
      faculty{
        id code nameLocal nameEng
      }
      department{
        id code nameLocal nameEng
      }
      zoneGroup{
        id nameLocal nameEng
      }
    }
  }
`;

